export const SET_CREDIT_FORM = 'SET_CREDIT_FORM';
export const SAVE_CREDIT_FORM = 'SAVE_CREDIT_FORM';
export const RECEIVE_COMMERCIAUX = 'RECEIVE_COMMERCIAUX';
